import { VerimotoInspectionTypeSelection } from "./verimoto.domain";

export type EnableTilesConfigType = 'enabled' | 'disabled' | 'terminated' | 'internal';

export type EnableTilesConfig = {
  AssetFinance: EnableTilesConfigType,
  BusinessLoans: EnableTilesConfigType,
  InsurancePremium: EnableTilesConfigType,
  BusinessOverdraft: EnableTilesConfigType,
}

export type ApplicationSubmissionType = {
  disabledMessage: string,
  internalAccessMessage: string,
} & EnableTilesConfig;

export type VerimotoLenderType = {
  name: string;
  guid: string;
}

export type UpdateServiceWorkerConfig = {
  enable: boolean;
  debugLogging: boolean;
  pageRefresh: boolean;
  skipRefreshConfim: boolean;
}

export type PortalEnvironmentType =  {
  production: boolean,
  serviceWorker: UpdateServiceWorkerConfig,
  gitTag: string,
  gitHash: string,
  api2Host: string,
  agmApiKey: string,
  submitApplicationTermsAndConditionsUrl: string,
  helpCenterUrl: string,
  facebookUrl: string,
  linkedinUrl: string,
  fxApiKey: string,
  invoiceFinanceUrl: string,
  contactUsUrl: string,
  brokerProductGuideUrl: string,
  assetProductGuideUrl: string,
  bankStatements: string,
  idVerify: string,
  GrowFinanceGroupSalesforceId: string,
  OverdraftCustomerRecordTypeId: string,
  GrowFinanceGroupName: string,
  appInsightsKey: string | null,
  autoRefreshToken: boolean,
  applicationSubmission: ApplicationSubmissionType,
  localStorage: {
    encryptionKey: string,
  },
  verimoto: {
    lender: VerimotoLenderType,
    verimotoInspectionTypes: VerimotoInspectionTypeSelection[]
  },
  customerPortalUrl: string,
  portalUrlPrefix: string,
  syncAuth?: string,
  awsCognitoIdentityPoolId: string,
  awsCognitoRegion: string,
  livenessThreshold: number,
  faceCompareRetryTimes: number,
  frankieOnePortalUrl: string,
  pingToken?: string,
  adminSecretForSystemConnections?: string,
};
